import { useState } from 'react';
import { FormModal, FormField, Input } from '../../ui';
import type { ProjectCreate, ProjectRead } from '../../../types/clustering';

interface ProjectCreateModalProps {
  isOpen: boolean;
  initial?: ProjectRead | null;
  isSubmitting?: boolean;
  onClose: () => void;
  onSubmit: (body: ProjectCreate) => void | Promise<void>;
}

export function ProjectCreateModal({
  isOpen,
  initial,
  isSubmitting = false,
  onClose,
  onSubmit,
}: ProjectCreateModalProps) {
  const [name, setName] = useState(initial?.name ?? '');
  const [description, setDescription] = useState(initial?.description ?? '');
  const [error, setError] = useState<string | null>(null);

  const isEdit = !!initial;

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isSubmitting) return;
    const trimmed = name.trim();
    if (trimmed.length < 1) {
      setError('Project name is required');
      return;
    }
    setError(null);
    await onSubmit({ name: trimmed, description: description.trim() || null });
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={isEdit ? 'Rename project' : 'New clustering project'}
      size="small"
      onSubmit={handleSubmit}
      submitLabel={isEdit ? 'Save' : 'Create'}
      isSubmitting={isSubmitting}
    >
      <FormField label="Name" htmlFor="clustering-project-name" error={error ?? undefined}>
        <Input
          id="clustering-project-name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. Blog content clusters"
          error={!!error}
          fullWidth
          autoFocus
        />
      </FormField>
      <FormField label="Description (optional)" htmlFor="clustering-project-description">
        <Input
          id="clustering-project-description"
          value={description ?? ''}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Short summary"
          fullWidth
        />
      </FormField>
    </FormModal>
  );
}
